import * as R from 'ramda';
import { useQuery } from '@cd/react-query';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';

export function useGetOrgInfo(dispatch) {
	const url = `/account/legal/org/get/info/`;

	return useQuery(['useGetOrgInfo'], () =>
		postJSONPS('GET', url).then(
			either(e => {
				dispatch({ type: 'post error', e });
				throw new Error(e);
			}, R.identity)
		)
	);
}
